import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { InitialScreenComponent } from './components/screens/initial-screen/initial-screen.component';
import { IdentificationComponent } from './components/screens/identification/identification.component';
import { CompanyAssociationComponent } from './components/screens/company-association/company-association.component';
import { BasicInfoScreenComponent } from './components/screens/basic-info-screen/basic-info-screen.component';
import { BasicInfoScreenComponent as BasicInfoScreenComponentFI } from './components/screens/basic-info-screen/basic-info-screen-fi.component';
import { BasicInfoScreenComponent as BasicInfoScreenComponentNL } from './components/screens/basic-info-screen/basic-info-screen-nl.component';
import { BasicInfoService } from './services/basic-info.service';
import { StartImproveComponent } from './components/screens/start-improve/start-improve.component';
import { PurposeComponent } from './components/screens/purpose/purpose.component';
import { AuthService } from './services/auth.service';
import { GuarantorComponent } from './components/screens/guarantor/guarantor.component';
import { TurnoverComponent } from './components/screens/turnover/turnover.component';
import { MonthlySalesComponent } from './components/screens/monthly-sales/monthly-sales.component';
import { AccountingUploadComponent } from './components/screens/accounting-upload/accounting-upload.component';
import { AccountDataComponent } from './components/screens/account-data/account-data.component';
import { ChannelComponent } from './components/screens/channel/channel.component';
import { SecuritiesComponent } from './components/screens/securities/securities.component';
import { RealEstateComponent } from './components/screens/real-estate/real-estate.component';
import { OtherSecuritiesComponent } from './components/screens/other-securities/other-securities.component';
import { SummaryComponent } from './components/screens/summary/summary.component';
import { ResellerComponent } from './components/screens/reseller/reseller.component';
import { IdentificationGuard } from 'src/app/services/identification.guard';
import { NoIdinBankComponent } from './components/screens/no-idin-bank/no-idin-bank.component';
import { BigTicketComponent } from './components/screens/big-ticket/big-ticket.component';
import { BigTicketComponent as BigTicketComponentFI } from './components/screens/big-ticket/big-ticket-fi.component';
import { BigTicketComponent as BigTicketComponentNL } from './components/screens/big-ticket/big-ticket-nl.component';
import { BigTicketPurposeComponent } from './components/screens/big-ticket-purpose/big-ticket-purpose.component';
import { PersonalContactComponent } from './components/screens/personal-contact/personal-contact.component';
import { IbanComponent } from './components/screens/iban/iban.component';
import { InitAppComponent } from './components/screens/init-app/init-app.component';
import { HighAmountForTurnoverComponent } from './components/screens/high-amount-for-turnover/high-amount-for-turnover.component';
import { TmEmailSentComponent } from './components/screens/tm-email-sent/tm-email-sent.component';
import { TmidentifyComponent } from './components/screens/tmidentify/tmidentify.component';
import { GenericFileUploadComponent } from './components/screens/generic-file-upload/generic-file-upload.component';
import { SmsUnsubscribeComponent } from './components/screens/sms-unsubscribe/sms-unsubscribe.component';

const routes: Routes = [
  {
    path: 'basic-info',
    component: BasicInfoScreenComponent,
  },
  {
    path: 'turnover',
    component: TurnoverComponent,
    canActivate: [BasicInfoService],
  },
  {
    path: 'high-amount-for-turnover',
    component: HighAmountForTurnoverComponent,
    canActivate: [BasicInfoService],
  },
  {
    path: 'identification',
    component: IdentificationComponent,
    canActivate: [IdentificationGuard],
  },
  {
    path: 'company-association',
    component: CompanyAssociationComponent,
    canActivate: [BasicInfoService],
  },
  {
    path: 'start-improve',
    component: StartImproveComponent,
    canActivate: [AuthService],
  },
  {
    path: 'purpose',
    component: PurposeComponent,
    canActivate: [AuthService],
  },
  {
    path: 'guarantor',
    component: GuarantorComponent,
    canActivate: [AuthService],
  },
  {
    path: 'monthly-sales',
    component: MonthlySalesComponent,
    canActivate: [BasicInfoService],
  },
  {
    path: 'accounting-upload',
    component: AccountingUploadComponent,
    canActivate: [AuthService],
  },
  {
    path: 'account-data',
    component: AccountDataComponent,
    canActivate: [AuthService],
  },
  {
    path: 'real-estate',
    component: RealEstateComponent,
    canActivate: [AuthService],
  },
  {
    path: 'securities',
    component: SecuritiesComponent,
    canActivate: [AuthService],
  },
  {
    path: 'other-securities',
    component: OtherSecuritiesComponent,
    canActivate: [AuthService],
  },
  {
    path: 'channel',
    component: ChannelComponent,
    canActivate: [AuthService],
  },
  {
    path: 'summary',
    component: SummaryComponent,
    canActivate: [AuthService],
  },
  {
    path: 'partner',
    component: ResellerComponent,
  },
  {
    path: 'no-idin-bank',
    component: NoIdinBankComponent,
    canActivate: [BasicInfoService],
  },
  {
    path: 'big-ticket',
    component: BigTicketComponent,
  },
  {
    path: 'big-purpose',
    component: BigTicketPurposeComponent,
    canActivate: [AuthService],
  },
  {
    path: 'personal-contact',
    component: PersonalContactComponent,
    canActivate: [AuthService],
  },
  {
    path: 'iban',
    component: IbanComponent,
    canActivate: [AuthService],
  },
  {
    path: 'init-app',
    component: InitAppComponent,
    canActivate: [BasicInfoService],
  },
  {
    path: 'tm-email-sent',
    component: TmEmailSentComponent,
    canActivate: [BasicInfoService],
  },
  {
    path: 'tmidentify',
    component: TmidentifyComponent,
  },
  {
    path: 'MT940',
    component: GenericFileUploadComponent,
    canActivate: [AuthService],
  },
  {
    path: 'unsubscribe',
    component: SmsUnsubscribeComponent,
  },
  { path: '**', pathMatch: 'full', redirectTo: 'basic-info' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}

export const RoutedComponents = [
  InitialScreenComponent,
  IdentificationComponent,
  BasicInfoScreenComponent,
  StartImproveComponent,
  PurposeComponent,
  GuarantorComponent,
  TurnoverComponent,
  MonthlySalesComponent,
  CompanyAssociationComponent,
  AccountingUploadComponent,
  AccountDataComponent,
  ChannelComponent,
  RealEstateComponent,
  SecuritiesComponent,
  OtherSecuritiesComponent,
  SummaryComponent,
  BasicInfoScreenComponentFI,
  BasicInfoScreenComponentNL,
  ResellerComponent,
  NoIdinBankComponent,
  BigTicketComponent,
  BigTicketComponentFI,
  BigTicketComponentNL,
  BigTicketPurposeComponent,
  PersonalContactComponent,
  IbanComponent,
  InitAppComponent,
  HighAmountForTurnoverComponent,
  TmEmailSentComponent,
  TmidentifyComponent,
  GenericFileUploadComponent,
  SmsUnsubscribeComponent,
];
